'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';
import { useAdBlock } from '@/contexts/AdBlockContext';

const DIRECT_LINK = 'https://defrostgauntlet.com/y8bi1av7c?key=dd96a8257036ec2245a2bf3d2c07a0dd';
const COOLDOWN_ADBLOCK_MS    = 2 * 60 * 1000;  // 2 phút
const COOLDOWN_NO_ADBLOCK_MS = 10 * 60 * 1000; // 10 phút

const LS_KEY = 'direct_link_last_opened';

function getLastOpened(): number {
  try {
    return parseInt(localStorage.getItem(LS_KEY) ?? '0', 10) || 0;
  } catch {
    return 0;
  }
}

function setLastOpened(ts: number): void {
  try {
    localStorage.setItem(LS_KEY, String(ts));
  } catch {
    // localStorage bị block (private mode, storage full, v.v.)
  }
}

export function DirectLinkTracker() {
  const pathname = usePathname();
  const isFirstRender = useRef(true);
  const isFirstClick = useRef(true);
  const { hasAdBlock } = useAdBlock();

  useEffect(() => {
    if(!hasAdBlock) return; // ✅ Chỉ áp dụng cho user có adblock

    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    // if (isFirstClick.current) {
    //   isFirstClick.current = false;
    //   return;
    // }

    const now = Date.now();
    const cooldown = hasAdBlock ? COOLDOWN_ADBLOCK_MS : COOLDOWN_NO_ADBLOCK_MS;
    const lastOpened = getLastOpened();

    if (now - lastOpened < cooldown) return;

    setLastOpened(now);

    if (hasAdBlock) {
      const current_url = window.location.href;
      window.open(current_url, '_blank', 'noopener');
      window.location.href = DIRECT_LINK;
    } else {
      window.open(DIRECT_LINK, '_blank', 'noopener');
    }
  }, [pathname]);

  return null;
}